import { __assign } from "tslib";
import React, { forwardRef } from "react";
import { useConfig } from "../_util/config-context";
export var BackDrop = forwardRef(function (_a, ref) {
    var zIndex = _a.zIndex, _b = _a.style, style = _b === void 0 ? {} : _b;
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", { ref: ref, className: classPrefix + "-backdrop", style: __assign({ zIndex: zIndex }, style) }));
});
//# sourceMappingURL=BackDrop.js.map